import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type CompleteValidationMessageFragment = { __typename?: 'ValidationMessage', code: string, field?: string | null, message?: string | null };

export const CompleteValidationMessage = /*#__PURE__*/ gql`
    fragment CompleteValidationMessage on ValidationMessage {
  code
  field
  message
}
    ` as unknown as DocumentNode<CompleteValidationMessageFragment, unknown>;

        

        
export const useCompleteValidationMessageFragment = (
  input: string | Omit<UseFragmentOptions<CompleteValidationMessageFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'ValidationMessage' } };
    return input;
  })();

  return useFragment<CompleteValidationMessageFragment>({
    fragment: CompleteValidationMessage,
    fragmentName: 'CompleteValidationMessage',
    ...options,
  });
};
  
        